import { render, staticRenderFns } from "./MPSBase.vue?vue&type=template&id=8a7d97c0&scoped=true&"
import script from "./MPSBase.vue?vue&type=script&lang=ts&"
export * from "./MPSBase.vue?vue&type=script&lang=ts&"
import style0 from "./MPSBase.vue?vue&type=style&index=0&lang=css&"
import style1 from "./MPSBase.vue?vue&type=style&index=1&id=8a7d97c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a7d97c0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemGroup } from 'vuetify/lib/components/VList';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VBtn,VCard,VIcon,VList,VListItem,VListItemGroup,VSnackbar})
